interface GenerateFeedbackParams {
  action: '매수' | '매도';
  price: number;
  quantityValue: number;
  currentPrice: number;
}

/**
 * 거래 피드백 생성
 */
export const generateFeedback = ({
  action,
  price,
  quantityValue,
  currentPrice,
}: GenerateFeedbackParams): {
  message: string;
  type: 'positive' | 'negative' | 'neutral' | 'tip';
  timestamp: number;
} => {
  const feedbacks = {
    buy: {
      positive: [
        '좋은 매수 타이밍이었어요! 현재 가격이 지지선 근처에서 매수하셨네요.',
        '적절한 분할 매수로 리스크를 잘 관리하고 계세요.',
        '거래량이 증가하는 구간에서 매수하셨네요. 좋은 판단입니다!',
      ],
      negative: [
        '고점 근처에서 매수하셨네요. 다음엔 저점을 노려보세요.',
        '거래량이 적은 구간에서 매수하셨습니다. 유동성을 확인해보세요.',
        '한 번에 너무 많이 매수하셨네요. 분할 매수를 고려해보세요.',
      ],
      tip: [
        '이 구간에서 매수할 때는 거래량도 함께 확인해보세요.',
        '지지선과 저항선을 파악하면 더 좋은 매수 타이밍을 잡을 수 있어요.',
        'RSI나 MACD 같은 보조지표도 참고해보세요.',
      ],
    },
    sell: {
      positive: [
        '적절한 매도 타이밍이었어요! 수익을 잘 실현하셨네요.',
        '손절매로 리스크를 잘 관리하고 계세요.',
        '고점에서 매도하셨네요. 훌륭한 판단입니다!',
      ],
      negative: [
        '저점에서 매도하셨네요. 다음엔 반등을 기다려보세요.',
        '너무 일찍 매도하셨습니다. 추세를 더 분석해보세요.',
        '손실을 줄이기 위해 분할 매도를 고려해보세요.',
      ],
      tip: [
        '매도할 때는 이동평균선을 참고해보세요.',
        '거래량이 급증하는 구간에서 매도하면 좋은 결과를 얻을 수 있어요.',
        '손절매 기준을 미리 정해두고 거래하세요.',
      ],
    },
  };

  const actionType = action === '매수' ? 'buy' : 'sell';
  const priceChange = ((currentPrice - price) / price) * 100;

  let feedbackType: 'positive' | 'negative' | 'neutral' | 'tip';
  let message: string;

  if (actionType === 'buy') {
    if (priceChange > 2) {
      feedbackType = 'positive';
      message =
        feedbacks.buy.positive[
          Math.floor(Math.random() * feedbacks.buy.positive.length)
        ];
    } else if (priceChange < -2) {
      feedbackType = 'negative';
      message =
        feedbacks.buy.negative[
          Math.floor(Math.random() * feedbacks.buy.negative.length)
        ];
    } else {
      feedbackType = 'tip';
      message =
        feedbacks.buy.tip[Math.floor(Math.random() * feedbacks.buy.tip.length)];
    }
  } else {
    if (priceChange < -2) {
      feedbackType = 'positive';
      message =
        feedbacks.sell.positive[
          Math.floor(Math.random() * feedbacks.sell.positive.length)
        ];
    } else if (priceChange > 2) {
      feedbackType = 'negative';
      message =
        feedbacks.sell.negative[
          Math.floor(Math.random() * feedbacks.sell.negative.length)
        ];
    } else {
      feedbackType = 'tip';
      message =
        feedbacks.sell.tip[
          Math.floor(Math.random() * feedbacks.sell.tip.length)
        ];
    }
  }

  return { message, type: feedbackType, timestamp: Date.now() };
};

